import { urlBaseLeadCollector } from "../config";
import axiosInstance from "../../services/config/axiosinstance";

export default async function saveConfig(
  eventId = '',
  config = '',
  value = '',
) {
  try {
    const _config = {
      method: 'POST',
      url: `${urlBaseLeadCollector}/adminPlusConfig/saveConfig`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        adminPlusEventId: eventId,
        config: config,
        value: value,
      }
    };

    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return null;
  } catch (error) {
    console.log('Error saveConfig', error);
    throw error;
  }
}
